<div class="wrapper">
  <div class="title">Order details:</div>
  <ngx-json-viewer [json]="order"></ngx-json-viewer>
</div>
